import { render, staticRenderFns } from "./ChangeRoleTip.vue?vue&type=template&id=31cb70aa&scoped=true"
import script from "./ChangeRoleTip.vue?vue&type=script&lang=js"
export * from "./ChangeRoleTip.vue?vue&type=script&lang=js"
import style0 from "./ChangeRoleTip.vue?vue&type=style&index=0&id=31cb70aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cb70aa",
  null
  
)

export default component.exports